import { BlockEditProps, registerBlockType } from '@wordpress/blocks'
import React from 'react'
import config from './block.json'
import { InnerBlocks, useBlockProps } from '@wordpress/block-editor'
import { useSelect } from '@wordpress/data'

function BlockEditor(props: BlockEditProps<{}>) {
  const blockProps = useBlockProps()
  const { hasChildBlocks } = useSelect(
    (select) => {
      const { getBlockOrder } = select('core/block-editor') as any

      return {
        hasChildBlocks: getBlockOrder(props.clientId).length > 0
      }
    },
    [props.clientId]
  )

  return (
    <div {...blockProps}>
      <InnerBlocks
        renderAppender={
          hasChildBlocks ? undefined : () => <InnerBlocks.ButtonBlockAppender />
        }
      />
    </div>
  )
}

registerBlockType(config.name, {
  ...config,
  attributes: [],

  edit: BlockEditor,

  save() {
    return <InnerBlocks.Content />
  }
})
